// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import MaskedInput from 'react-text-mask';
import _ from 'lodash';
// local
// api
import Patient from 'app/api/others';
// views
import SaveUpdateModal from './SaveUpdateModal';
import DropdownClient from 'app/ui/commons/DropdownClient';
import DropdownBRState from 'app/ui/commons/DropdownBRState';
import DropdownSupplier from 'app/ui/commons/DropdownSupplier';
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// libs
import t from 'app/lib/i18n';
import { _val, onlyNumberFilter, sortString } from 'app/lib/helper';
import { CPF_MASK, PHONE_MASK, ZIP_MASK, PRESCRIPTION_MASK } from 'app/lib/masks';
import { isValidCPF, isFormValid, isValidCEP, isValidPhone, removeReadOnly } from 'app/lib/formHelper';
// actions
import { ACTION } from 'app/redux/actions/modal';
import { create, update } from 'app/redux/actions/patient/data';
// consts
import { STATUS, PERIOD_TYPE } from 'salvus-shared/consts/patient';
import { TYPE as CLIENT_TYPE, STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';
import { CYLINDER_PRESSURE_MAP } from 'salvus-shared/consts/cylinder';

class PatientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.initForm(),
            errors: {},
            periodTypes: this.initPeriodTypes(),
            cylinderSizes: this.initCylinderSizes(),
            searchAddress: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isOpened: isOpenedP } = this.props.modalSaveUpdate;
        const { isOpened: isOpenedN, action: actionN, data: dataN } = nextProps.modalSaveUpdate;

        if (!isOpenedP && isOpenedN) {
            const values = actionN === ACTION.UPDATE ? dataN : {};
            const { client } = nextProps.auth.account;
            if (client.type !== CLIENT_TYPE.SALVUS) {
                values.clientId = client.id;
            }
            this.setState({ form: this.initForm(values), errors: {} });
        }
    }

    initForm(values = {}) {
        return {
            id: _val(values.id, null),
            clientId: _val(values.clientId, null),
            serviceNumber: _val(values.serviceNumber),
            cpf: _val(values.cpf),
            rg: _val(values.rg),
            name: _val(values.name),
            healthInsurence: _val(values.healthInsurence),
            prescription: _val(values.prescription, 0),
            periodType: values.periodType,
            cylinders: _val(values.cylinders, 0),
            cylinderSize: _val(values.cylinderSize),
            supplierId: _val(values.supplierId, null),
            phone1: _val(values.phone1),
            phone2: _val(values.phone2),
            phone3: _val(values.phone3),
            status: _val(values.status, 0),
            address: _val(values.address),
            complement: _val(values.complement),
            number: _val(values.number, null),
            district: _val(values.district),
            city: _val(values.city),
            state: _val(values.state),
            zipCode: _val(values.zipCode),
        };
    }

    initPeriodTypes() {
        const types = Object.keys(PERIOD_TYPE).map(key => {
            const value = PERIOD_TYPE[key];
            return {
                text: t(`patient_period_type_${value}`),
                value,
            };
        });
        types.sort((a, b) => sortString(a.text, b.text));
        return types;
    }

    initCylinderSizes() {
        const keys = Object.keys(CYLINDER_PRESSURE_MAP).map(k => parseFloat(k, 10));
        keys.sort(function(a, b) {
            return a - b;
        });
        return keys.map(key => {
            return {
                text: `${key} m³`,
                value: key,
            };
        });
    }

    validateForm(form, field) {
        const errors = {};

        const serviceNumber = form.serviceNumber;
        if (!field || field === 'serviceNumber') {
            if (_.isEmpty(serviceNumber)) {
                errors['serviceNumber'] = 'O campo atendimento é obrigatório.';
            } else {
                errors['serviceNumber'] = undefined;
            }
        }

        const cpf = form.cpf;
        if (!field || field === 'cpf') {
            if (!_.isEmpty(cpf) && !isValidCPF(cpf)) {
                errors['cpf'] = 'O campo CPF não é válido.';
            } else {
                errors['cpf'] = undefined;
            }
        }

        const name = form.name;
        if (!field || field === 'name') {
            if (_.isEmpty(name)) {
                errors['name'] = 'O campo nome é obrigatório.';
            } else {
                errors['name'] = undefined;
            }
        }

        const clientId = form.clientId;
        if (!field || field === 'clientId') {
            if (clientId === null) {
                errors['clientId'] = 'O campo cliente é obrigatório.';
            } else {
                errors['clientId'] = undefined;
            }
        }

        const address = form.address;
        if (!field || field === 'address') {
            if (_.isEmpty(address)) {
                errors['address'] = 'O campo logradouro é obrigatório.';
            } else {
                errors['address'] = undefined;
            }
        }

        const number = form.number;
        if (!field || field === 'number') {
            if (number === null) {
                errors['number'] = 'O campo número é obrigatório.';
            } else {
                errors['number'] = undefined;
            }
        }

        const district = form.district;
        if (!field || field === 'district') {
            if (_.isEmpty(district)) {
                errors['district'] = 'O campo bairro é obrigatório.';
            } else {
                errors['district'] = undefined;
            }
        }

        const city = form.city;
        if (!field || field === 'city') {
            if (_.isEmpty(city)) {
                errors['city'] = 'O campo cidade é obrigatório.';
            } else {
                errors['city'] = undefined;
            }
        }

        const state = form.state;
        if (!field || field === 'state') {
            if (_.isEmpty(state)) {
                errors['state'] = 'O campo estado é obrigatório.';
            } else {
                errors['state'] = undefined;
            }
        }

        const zipCode = form.zipCode;
        if (!field || field === 'zipCode') {
            if (_.isEmpty(zipCode)) {
                errors['zipCode'] = 'O campo CEP é obrigatório.';
            } else if (!isValidCEP(zipCode)) {
                errors['zipCode'] = 'O campo CEP não é válido.';
            } else {
                errors['zipCode'] = undefined;
            }
        }

        const supplierId = form.supplierId;
        if (!field || field === 'supplierId') {
            if (supplierId === null) {
                errors['supplierId'] = 'O campo fornecedor é obrigatório.';
            } else {
                errors['supplierId'] = undefined;
            }
        }

        const healthInsurence = form.healthInsurence;
        if (!field || field === 'healthInsurence') {
            if (_.isEmpty(healthInsurence)) {
                errors['healthInsurence'] = 'O campo plano de saúde é obrigatório.';
            } else {
                errors['healthInsurence'] = undefined;
            }
        }

        const periodType = form.periodType;
        if (!field || field === 'periodType') {
            if (!Object.values(PERIOD_TYPE).includes(periodType)) {
                errors['periodType'] = 'O campo tipo de uso é obrigatório.';
            } else {
                errors['periodType'] = undefined;
            }
        }

        const cylinders = form.cylinders;
        if (!field || field === 'cylinders') {
            if (cylinders <= 0) {
                errors['cylinders'] = 'O campo número de cilindros tem que ser maior que 0.';
            } else {
                errors['cylinders'] = undefined;
            }
        }

        const cylinderSize = form.cylinderSize;
        if (!field || field === 'cylinderSize') {
            if (
                !Object.keys(CYLINDER_PRESSURE_MAP)
                    .map(k => parseFloat(k, 10))
                    .includes(cylinderSize)
            ) {
                errors['cylinderSize'] = 'O campo tamanho de cilindro é obrigatório.';
            } else {
                errors['cylinderSize'] = undefined;
            }
        }

        const phone1 = form.phone1;
        if (!field || field === 'phone1') {
            if (!_.isEmpty(phone1) && !isValidPhone(phone1)) {
                errors['phone1'] = 'O campo telefone principal não é válido.';
            } else {
                errors['phone1'] = undefined;
            }
        }

        const phone2 = form.phone2;
        if (!field || field === 'phone2') {
            if (!_.isEmpty(phone2) && !isValidPhone(phone2)) {
                errors['phone2'] = 'O campo telefone não é válido.';
            } else {
                errors['phone2'] = undefined;
            }
        }

        const phone3 = form.phone3;
        if (!field || field === 'phone3') {
            if (!_.isEmpty(phone3) && !isValidPhone(phone3)) {
                errors['phone3'] = 'O campo telefone não é válido.';
            } else {
                errors['phone3'] = undefined;
            }
        }

        return errors;
    }

    onChange = field => (e, target) => {
        const { value } = target || e.target;
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });

        // search address by zip code
        if(field === 'zipCode' && !errors.zipCode) {
            this.setState({ searchAddress: true });

            Patient.cep(form.zipCode).then((res) => {
                form.address = res.address;
                form.city = res.city;
                form.district = res.district;
                form.state = res.state;

                this.setState({ form, errors, searchAddress: false });
            }).catch(() => {
                errors['zipCode'] = 'CEP não encontrado.';
                this.setState({ form, errors, searchAddress: false });
            });
        } else {
            this.setState({ form, errors });
        };
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onConfirmModal = () => {
        // check if there is any error in the form
        const errors = this.validateForm(this.state.form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            // return false to not close the popup
            return false;
        }
        // if there are not errors, submit to the backend
        const { form } = this.state;
        const { action, onSuccessCallback } = this.props.modalSaveUpdate;
        if (action === ACTION.ADD) {
            this.props.dispatch(create(form));
        } else if (action === ACTION.UPDATE) {
            this.props.dispatch(update(form.id, form, onSuccessCallback));
        }
        // return false to not close the popup
        return false;
    };

    render() {
        // props
        const { dispatch, modalSaveUpdate, auth } = this.props;
        const options = {
            dispatch,
            title: 'Paciente',
            onConfirmModal: this.onConfirmModal,
            action: modalSaveUpdate.action,
            isOpened: modalSaveUpdate.isOpened,
            loading: modalSaveUpdate.loading,
            error: modalSaveUpdate.error,
        };
        // state
        const { form, errors, periodTypes, cylinderSizes, searchAddress } = this.state;
        return (
            <SaveUpdateModal id="patientModal" options={options}>
                <Form>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Atendimento" error={errors['serviceNumber']} />}
                            placeholder="Atendimento"
                            width={5}
                            value={form.serviceNumber}
                            onChange={this.onChange('serviceNumber')}
                            error={this.hasError('serviceNumber')}
                            maxLength="15"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label="RG"
                            placeholder="RG"
                            width={5}
                            value={form.rg}
                            onChange={onlyNumberFilter(this.onChange('rg'))}
                            maxLength="15"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label="CPF" error={errors['cpf']} optional/>}
                            control={MaskedInput}
                            mask={CPF_MASK}
                            guide
                            placeholder="CPF"
                            type="text"
                            width={6}
                            value={form.cpf}
                            onChange={this.onChange('cpf')}
                            error={this.hasError('cpf')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Nome" error={errors['name']} />}
                            placeholder="Nome"
                            width={16}
                            value={form.name}
                            onChange={this.onChange('name')}
                            error={this.hasError('name')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    {modalSaveUpdate.action === ACTION.ADD &&
                        auth.account.client.type === CLIENT_TYPE.SALVUS && (
                            <DropdownClient
                                width={16}
                                value={form.clientId}
                                filter={[CLIENT_STATUS.NEW, CLIENT_STATUS.ENABLED]}
                                onChange={this.onChange('clientId')}
                                error={errors['clientId']}
                            />
                        )}
                    <Form.Group>
                        <Form.Input
                            control={MaskedInput}
                            mask={ZIP_MASK}
                            guide
                            label={<ErrorLabel label="CEP" error={errors['zipCode']} />}
                            type="text"
                            width={4}
                            value={form.zipCode}
                            onChange={this.onChange('zipCode')}
                            error={this.hasError('zipCode')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Logradouro" error={errors['address']} />}
                            placeholder="Logradouro"
                            width={12}
                            value={form.address}
                            onChange={this.onChange('address')}
                            error={this.hasError('address')}
                            maxLength="255"
                            readOnly
                            onFocus={removeReadOnly}
                            loading={searchAddress}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Número" error={errors['number']} />}
                            placeholder="Número"
                            width={4}
                            value={form.number}
                            onChange={this.onChange('number')}
                            error={this.hasError('number')}
                            maxLength="9"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label="Complemento"
                            placeholder="Complemento"
                            width={12}
                            value={form.complement}
                            onChange={this.onChange('complement')}
                            maxLength="255"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Bairro" error={errors['district']} />}
                            placeholder="Bairro"
                            width={6}
                            value={form.district}
                            onChange={this.onChange('district')}
                            error={this.hasError('district')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                            loading={searchAddress}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Cidade" error={errors['city']} />}
                            placeholder="Cidade"
                            width={6}
                            value={form.city}
                            onChange={this.onChange('city')}
                            error={this.hasError('city')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                            loading={searchAddress}
                        />
                        <DropdownBRState width={4} value={form.state} onChange={this.onChange('state')} error={errors['state']} loading={searchAddress} />
                    </Form.Group>
                    <Form.Group>
                        <DropdownSupplier
                            label={<ErrorLabel label="Fornecedor" error={errors['supplierId']} />}
                            placeholder="Selecione o fornecedor"
                            width={16}
                            value={form.supplierId}
                            clientId={form.clientId}
                            onChange={this.onChange('supplierId')}
                            error={this.hasError('supplierId')}
                            disabled={form.status === STATUS.INITIALIZED || !form.clientId}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Plano de Saúde" error={errors['healthInsurence']} />}
                            placeholder="Plano de Saúde"
                            width={6}
                            value={form.healthInsurence}
                            onChange={this.onChange('healthInsurence')}
                            error={this.hasError('healthInsurence')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Field width={6} />
                        <Form.Field width={6}>
                        <Form.Input
                            label={<ErrorLabel label="Prescrição (L/min)" error={errors['prescription']} />}
                            control={MaskedInput}
                            mask={PRESCRIPTION_MASK}
                            guide
                            placeholder="00.0" 
                            type="text"
                            value={form.prescription}
                            onChange={this.onChange('prescription')}
                            error={this.hasError('prescription')}
                            maxLength="4"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group>
                        <CustomDropdown
                            label={<ErrorLabel label="Tipo de Uso" error={errors['periodType']} />}
                            placeholder="Tipo de Uso"
                            selection
                            width={6}
                            options={periodTypes}
                            value={form.periodType}
                            onChange={this.onChange('periodType')}
                            error={this.hasError('periodType')}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Número de Cilindros" error={errors['cylinders']} />}
                            placeholder="0"
                            type="text"
                            width={6}
                            value={form.cylinders}
                            onChange={onlyNumberFilter(this.onChange('cylinders'))}
                            disabled={form.status === STATUS.INITIALIZED}
                            error={this.hasError('cylinders')}
                            maxLength="2"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <CustomDropdown
                            label={<ErrorLabel label="Tamanho dos cilindros" error={errors['cylinderSize']} />}
                            placeholder="Tamanho dos cilindros"
                            selection
                            width={6}
                            options={cylinderSizes}
                            value={form.cylinderSize}
                            disabled={form.status === STATUS.INITIALIZED}
                            onChange={this.onChange('cylinderSize')}
                            error={this.hasError('cylinderSize')}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Fone Principal" error={errors['phone1']} optional />}
                            control={MaskedInput}
                            mask={PHONE_MASK}
                            guide
                            type="text"
                            width={6}
                            value={form.phone1}
                            onChange={this.onChange('phone1')}
                            error={this.hasError('phone1')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Fone" error={errors['phone2']} optional />}
                            control={MaskedInput}
                            mask={PHONE_MASK}
                            guide
                            type="text"
                            width={6}
                            value={form.phone2}
                            onChange={this.onChange('phone2')}
                            error={this.hasError('phone2')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Fone" error={errors['phone3']} optional />}
                            control={MaskedInput}
                            mask={PHONE_MASK}
                            guide
                            type="text"
                            width={6}
                            value={form.phone3}
                            onChange={this.onChange('phone3')}
                            error={this.hasError('phone3')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                </Form>
            </SaveUpdateModal>
        );
    }
}

PatientModal.propTypes = {
    modalSaveUpdate: PropTypes.object,
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    modalSaveUpdate: state.modalSaveUpdate,
});
export default connect(mapStateToProps)(PatientModal);
